module.exports = __webpack_public_path__ + "static/media/icon-sunset.6167e8ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-sunset.svg
// module id = 1346
// module chunks = 0